<script>
    import AccountSelect from "./AccountSelect.svelte";

    export let account = null;
    export let accountId = null;
    export let disabled = false;

    const selectAccount = ({detail}) => {
        account = detail;
        accountId = detail.id;
    }

    const clear = () => {
        account = null;
        accountId = null;
    }
</script>


{#if account}
    <div class="input-group">
        <div class="form-control">{ account.name }</div>
        {#if !disabled}
            <span class="input-group-text pointer" title="clear account" on:click="{ clear }">&times;</span>
        {/if}
    </div>
{:else}
    <AccountSelect on:select={ selectAccount } placeholder="select account"/>
{/if}
